import { render, staticRenderFns } from "./switchBtn.vue?vue&type=template&id=7124fd6c&scoped=true&lang=pug"
import script from "./switchBtn.vue?vue&type=script&lang=js"
export * from "./switchBtn.vue?vue&type=script&lang=js"
import style0 from "./switchBtn.vue?vue&type=style&index=0&id=7124fd6c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7124fd6c",
  null
  
)

export default component.exports